import { render, staticRenderFns } from "./nav-subitem.vue?vue&type=template&id=5c340608&scoped=true&"
import script from "./nav-subitem.vue?vue&type=script&lang=js&"
export * from "./nav-subitem.vue?vue&type=script&lang=js&"
import style0 from "./nav-subitem.vue?vue&type=style&index=0&id=5c340608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c340608",
  null
  
)

export default component.exports